import { createApp, ref } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { initYupValidate } from "@/core/plugins/yup-validate";

import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";

//import CKEditor from "ckeditor4-vue";
//import CKEditor from "@ckeditor/ckeditor5-vue";

// import { defineRule, configure } from "vee-validate";
// import { required } from "@vee-validate/rules";
// import { localize, setLocale } from "@vee-validate/i18n";
// import en from "@vee-validate/i18n/dist/locale/en.json";
// import cn from "@vee-validate/i18n/dist/locale/zh_CN.json";
// defineRule("required", required);
// configure({
//   generateMessage: localize({ en, cn })
// });
// configure({
//   generateMessage: localize({ en, cn }),
//   // generateMessage: localize({
//   //   en: {
//   //     messages: {
//   //       required: 'This field is required',
//   //     },
//   //   },
//   //   cn: {
//   //     messages: {
//   //       required: 'هذا الحقل مطلوب',
//   //     },
//   //   },
//   // }),
// });
//setLocale("cn");

import "@/core/plugins/prismjs";
const app = createApp(App);
app.use(store);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();
initYupValidate();
//app.use(CKEditor);
app.use(i18n);

app.mount("#app");
